import React, { useEffect, useState } from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';
import HeartIcon from '@mui/icons-material/Favorite';
import { theme } from 'venuescanner-js/theme';
import { ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { authService } from 'venuescanner-js/services/auth';
import NavbarButton from 'venuescanner-js/react/components/shared/NavbarButton';

const ShortListNavButton = () => {
  const [count, setCountState] = useState(
    window?.widgetsData?.shortlist_items?.length || 0,
  );

  useEffect(() => {
    const EVENT_NAME = 'shortlistCountUpdate';
    const updateCount = e => setCountState(e.detail.count);
    window.addEventListener(EVENT_NAME, updateCount);

    return () => window.removeEventListener(EVENT_NAME, updateCount);
  }, []);

  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  return (
    !!count && (
      <NavbarButton
        href='/shortlist'
        aria-label='shortlist'
        variant='contained'
        startIcon={<HeartIcon color='secondary' />}
        color='supportiveBurgundy'
        size='small'>
        {authService.isLoggedIn() && isMobile
          ? `${count}`
          : `Shortlist: ${count}`}
      </NavbarButton>
    )
  );
};

ShortListNavButton.propTypes = {
  spaces: PropTypes.number,
};

render(
  <ThemeProvider theme={theme}>
    <ShortListNavButton />
  </ThemeProvider>,
  document.getElementById('short-list-nav-button'),
);

export const renderShortListButton = () => {
  render(
    <ThemeProvider theme={theme}>
      <ShortListNavButton />
    </ThemeProvider>,
    document.getElementById('short-list-nav-button'),
  );
};
